import React, { useEffect, useState } from "react";
import { ProjectContainer } from "../styles/projectTab";
import XalqlarAdmin from "../assets/xalqlar-admin.png";
import CamperAdmin from "../assets/camper-admin.webp";
import { ProjectCard } from "./project-card";
const AdminDashboard = () => {
  const [opacity, setOpacity] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => {
      setOpacity(1);
    }, 200);

    return () => clearTimeout(timer);
  }, []);
  return (
    <ProjectContainer style={{ opacity, transition: "opacity 0.5s" }}>
      <ProjectCard
        link="https://xalqlar-dostligi.uz/auth/login"
        image={XalqlarAdmin}
        title="Xalqlar (admin-dashboard)"
        subtitle="Web application"
      />
      <ProjectCard
        link="https://admin-dashboard.camper.inomjonov.site"
        image={CamperAdmin}
        title="TRIPLi (admin-dashboard)"
        subtitle="Web applicationss"
      />
    </ProjectContainer>
  );
};

export default AdminDashboard;
